import { ProfileURL } from "./Network";

export const getProfileURL = (userId: string | number, photoFile?: string) => {
  if (!photoFile) return null;
  return `${ProfileURL}/${userId}/${photoFile}`;
};
